module.exports = __webpack_public_path__ + "static/img/egg_r_19.77a8bce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_19.png
// module id = S+VO
// module chunks = 1